// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"43581066","64":"89e93c9c","116":"ff43ed42","462":"5be29cf0","488":"ba730556","753":"a19d0a89","905":"004cefa1"}[chunkId] + ".chunk.js";
};